import { BasePresenter } from "@presenters/base/base.presenter";
import { IFormBudget } from "@interfaces/screens/form-budget.interface";
import { ILang } from "@models/*";
import {
  ICmdBasicDataProjectBudget,
  ICmdTableBudgetByProject,
  ICmdTableBudgetFFCC,
  ICmdTableBudgetFFRR,
} from "@models/";
import { useSelector } from "react-redux";
import {
  String,
  Enums,
  Utilities,
  queryString,
  Constants,
  Dictionary,
} from "@utils";
import DataGrid from "devextreme/ui/data_grid";
import { store } from "@/store";
import {
  BudgetService,
  IBudgetService,
} from "@services/proyecta/budget.service";

export class FormBudgetPresenter extends BasePresenter<IFormBudget> {
  public budgetStatus: any;
  public formSaveBudget: any;
  public currentlabels: Dictionary<string, string>;

  private currentLang: ILang;
  private currentBudget: any;
  private _service: IBudgetService;
  private _tablesContainsNulls: boolean;

  constructor(view: IFormBudget) {
    super(view);
    this.currentBudget = useSelector(
      this.context.budgetStore.selectCurrentBudget
    );
    this.budgetStatus = useSelector(
      this.context.budgetStore.selectbudgetStatus
    );
    this.formSaveBudget = useSelector(
      this.context.budgetStore.selectFormSaveBudget
    );
    this.currentLang = useSelector(this.context.sessionStore.selectLang);
    this.currentlabels = useSelector(this.context.sessionStore.selectLabels);
    this._service = new BudgetService();
    this._tablesContainsNulls = false;
  }
  //#region Public methods
  public get isAllowEdit() {
    return window.location.href.indexOf("edit?Id") > -1;
  }
  public onInitialize() {
    const readOnly = window.location.href.indexOf("view?Id") > -1;
    this.dispatcherUnsetSetLoading();
    if (readOnly) this.view.state.setReadOnly(readOnly);
    this.syncDispatcher(
      this.context.budgetStore.actions.setCurrentBudget(null)
    );

    const query = queryString.parseUrl(window.location.href.replace("#", ""))
      .query as any;
    if (!Utilities.isNullObject(query)) {
      if (!Utilities.isNullObject(query.Id)) {
        this.dispatcher(this.context.budgetStore.getBudget(query.Id));
      }
    }
  }
  public getAllFormMasters() {
    this.dispatcher(this.context.budgetStore.getAllFormMasters());
    this.dispatcher(this.context.budgetStore.getBudgetBasicDataColumns());
    this.dispatcher(this.context.budgetStore.getBudgetDetailColumns());
    this.dispatcher(this.context.budgetStore.getBasicBudgets(false));
  }
  public save() {
    this.dispatcherProgress(0);
    this.dispatcherPendingLoad(1);
    this.dispatcherSetLoading();
    this.dispatcherProgress(10);
    let budgetEntity = this.mappCurrentBudgetToBudgetEntity();
    const { tableBudgetByProject, tableFFCC, tableFFRR } = this.getTablesData();

    let userEmail = this.currentUser.currentUser.userPrincipalName;
    let validation: any = [];
    let isPepValid = true;
    let PPresCodProy: any = [];
    if (
      budgetEntity.PPresTipoPresId !== 2 &&
      Utilities.isNullObject(budgetEntity.Id)
    ) {
      if (typeof budgetEntity.PPresCodProy !== "string") {
        PPresCodProy = store
          .getState()
          .budget.basicBudgets.filter((data: any) => {
            return data.Id === budgetEntity.PPresCodProy;
          });
        PPresCodProy = PPresCodProy[0].PPresCodProy;
        validation = store
          .getState()
          .budget.basicBudgets.filter((data: any) => {
            return data.PPresCodProy === PPresCodProy;
          });
        validation = validation.filter((data: any) => {
          return data.PPresAnioId === budgetEntity.PPresAnioId;
        });
        budgetEntity = {
          ...budgetEntity,
          PPresCodProy: PPresCodProy,
          PPresPresupuestoId: parseInt(budgetEntity.PPresCodProy),
        };
      }
    }

    if(tableBudgetByProject && tableBudgetByProject.length){
      tableBudgetByProject.forEach(element => {
        let regex = /^\w{4}\.\w{4}\.\w{4}\.\w(.{6})$/gi
        let validatePep = regex.test(element.PPresCodPep.toString())
        if(!validatePep) isPepValid = false;
      });
    }

    if (Utilities.isNullObject(validation[0]) && isPepValid) {
      if (
        this.budgetStatus.yearId !== budgetEntity.PPresAnioId.toString() &&
        Utilities.isNullObject(budgetEntity.Id)
      ) {
        if (this._tablesContainsNulls) {
          const title = this.getLabel("alertMsgLocationTitle");
          const msg = this.getLabel("alertMsgLocation");
          Utilities.showConfirmation(msg, title).then((response) => {
            if (response) {
              this.dispatcherProgress(60);
              this._service
                .saveBudget(
                  budgetEntity,
                  this.currentBudget.projectExists,
                  tableBudgetByProject,
                  tableFFCC,
                  tableFFRR,
                  this.currentBudget.PPresTipoPresId,
                  userEmail
                )
                .then((budget: any) => {
                  this.dispatcher(
                    this.context.budgetStore.actions.getFormSaveBudget(budget)
                  );
                  this.dispatcherProgress(90);
                  this.dispatcherUnsetSetLoading();
                })
                .catch((err) => {
                  this.dispatcherUnsetSetLoading();
                  this.writeErrorLog(err, {
                    budgetEntity,
                    tableBudgetByProject,
                    tableFFCC,
                    tableFFRR,
                  }).then((guid: string) => {
                    Utilities.notifyError(
                      String.Format(
                        this.getLabel("No se pudo guardar el registro"),
                        guid
                      )
                    );
                  });
                });
            } else {
              this.dispatcherProgress(99);
              this.dispatcherUnsetSetLoading();
            }
          });
        } else {
          this.dispatcherProgress(50);
          this._service
            .saveBudget(
              budgetEntity,
              this.currentBudget.projectExists,
              tableBudgetByProject,
              tableFFCC,
              tableFFRR,
              this.currentBudget.PPresTipoPresId,
              userEmail
            )
            .then((budget: any) => {
              this.dispatcher(
                this.context.budgetStore.actions.getFormSaveBudget(budget)
              );
              this.dispatcherProgress(99);
              this.dispatcherUnsetSetLoading();
            })
            .catch((err) => {
              this.dispatcherUnsetSetLoading();
              this.writeErrorLog(err, {
                budgetEntity,
                tableBudgetByProject,
                tableFFCC,
                tableFFRR,
              }).then((guid: string) => {
                Utilities.notifyError(
                  String.Format(
                    this.getLabel("No se pudo guardar el registro"),
                    guid
                  )
                );
              });
            });
        }
      } else {
        if (this._tablesContainsNulls) {
          const title = this.getLabel("alertMsgLocationTitle");
          const msg = this.getLabel("alertMsgLocation");
          this.dispatcherProgress(60);
          Utilities.showConfirmation(msg, title).then((response) => {
            if (response) {
              this._service
                .updateBudget(
                  budgetEntity,
                  tableBudgetByProject,
                  tableFFCC,
                  tableFFRR,
                  userEmail
                )
                .then((budget: any) => {
                  this.dispatcher(
                    this.context.budgetStore.actions.getFormSaveBudget(budget)
                  );
                  this.dispatcherProgress(99);
                  this.dispatcherUnsetSetLoading();
                })
                .catch((err) => {
                  this.dispatcherProgress(10);
                  this.dispatcherUnsetSetLoading();
                  this.writeErrorLog(err, {
                    budgetEntity,
                    tableBudgetByProject,
                    tableFFCC,
                    tableFFRR,
                  }).then((guid: string) => {
                    Utilities.notifyError(
                      String.Format(
                        this.getLabel("No se pudo guardar el registro"),
                        guid
                      )
                    );
                  });
                });
            } else {
              this.dispatcherProgress(99);
              this.dispatcherUnsetSetLoading();
            }
          });
        } else {
          this._service
            .updateBudget(
              budgetEntity,
              tableBudgetByProject,
              tableFFCC,
              tableFFRR,
              userEmail
            )
            .then((budget: any) => {
              this.dispatcher(
                this.context.budgetStore.actions.getFormSaveBudget(budget)
              );
              this.dispatcherProgress(99);
              this.dispatcherUnsetSetLoading();
            })
            .catch((err) => {
              this.dispatcherProgress(10);
              this.dispatcherUnsetSetLoading();
              this.writeErrorLog(err, {
                budgetEntity,
                tableBudgetByProject,
                tableFFCC,
                tableFFRR,
              }).then((guid: string) => {
                Utilities.notifyError(
                  String.Format(
                    this.getLabel("No se pudo guardar el registro"),
                    guid
                  )
                );
              });
            });
        }
      }
    }else if(!isPepValid){
      this.dispatcherProgress(99);
      this.dispatcherUnsetSetLoading();
      Utilities.notifyError(this.currentlabels.get("errorCodePep"));
    }else{
      this.dispatcherProgress(99);
      this.dispatcherUnsetSetLoading();
    }
  }
  public updateId() {
    const query = queryString.parseUrl(window.location.href.replace("#", ""))
      .query as any;
    return Utilities.isNullEmptyObject(query.Id) ? true : false;
  }
  public OnRedirect(relativeUrl: string) {
    this.context.history.push(relativeUrl);
    window.location.reload();
  }
  public mappCurrentBudgetToBudgetEntity() {
    this.dispatcherProgress(20);
    let budgetEntity;
    if (
      this.currentBudget.PPresTipoPresId !== Enums.SystemParameters.BudgetTypeOn
    ) {
      budgetEntity = {
        PPresAnioId: this.currentBudget.Year[0].id,
        PPresTipoPresId: this.currentBudget.PPresTipoPresId,
        PPresCodProy: Array.isArray(this.currentBudget.PPresCodProy)
          ? this.currentBudget.PPresCodProy[0].label
          : this.currentBudget.PPresCodProy,
        PPresNumProy: this.currentBudget.PPresNumProy,
        OCTAVIALineaIntervencionId: this.currentBudget.LineaIntervencionId[0]
          .id,
        CodeConsecutive:
          this.currentBudget.Year[0].label +
          this.currentBudget.RegionCountry[0].code,
        Title: this.currentBudget.Title,
        Id: this.currentBudget.Id,
        PPresPresupuestoId: this.currentBudget.PPresPresupuestoId,
      } as ICmdBasicDataProjectBudget;
    } else {
      budgetEntity = {
        PPresAnioId: this.currentBudget.Year[0].id,
        PPresTipoPresId: this.currentBudget.PPresTipoPresId,
        Id: this.currentBudget.Id,
      } as ICmdBasicDataProjectBudget;
    }

    const countryRegionId = this.currentBudget.RegionCountry[0].id.toString();
    if (countryRegionId.indexOf(Constants.Globals.PREFFIX_RG) !== -1) {
      budgetEntity.OCTAVIARegionId = parseInt(
        countryRegionId.replace(Constants.Globals.PREFFIX_RG, String.Empty)
      );
    } else {
      budgetEntity.OCTAVIAPaisId = parseInt(countryRegionId);
    }

    return budgetEntity;
  }
  public getLabel(name: string) {
    if (!Utilities.isNullEmptyObject(this.currentlabels)) {
      return this.currentlabels.get(name);
    }
  }
  public onSaveData() {
    const notifyData: any = {};

    if (!Utilities.isNullObject(this.formSaveBudget)) {
      const source = `/proyecta/presupuesto/edit?Id=${this.formSaveBudget.Id}`;
      if (this.formSaveBudget.Id !== this.currentBudget.Id) {
        notifyData.message = this.getLabel("Guardado correctamente");
        notifyData.title = this.getLabel("Guardar");
      } else {
        notifyData.message = this.getLabel("Actualizado correctamente");
        notifyData.title = this.getLabel("Actualizar");
      }
      Utilities.notifySuccess(notifyData.message, notifyData.title).then(
        (data) => {
          this.OnRedirect(source);
        }
      );
    }
  }
  public get initRender() {
    return !Utilities.isNullEmptyObject(
      this.currentlabels.get("Datos básicos")
    );
  }
  //#endregion

  //#region Privated methods

  private mappCurrentTableByProjectEntity() {
    let newTable = this.getDataFromTable("table-by-project");

    if (newTable.length === 0) return null;

    let tablesByProject: Array<ICmdTableBudgetByProject> = newTable.map(
      (x: any) => {
        const entity: ICmdTableBudgetByProject = {
          ...this.getMonthsYearVales(x),
        };
        entity.Id = x.Id;
        entity.PPresTotalAnio = this.getTotalSum(entity);
        entity.OCTAVIAFinanciadorSapId =
          Utilities.isNullObject(x.FinanciadorSap) ||
          x.FinanciadorSap.length === 0
            ? null
            : x.FinanciadorSap[0];
        entity.PPresCodSubvencionId =
          Utilities.isNullObject(x.CodigoSubvencion) ||
          x.CodigoSubvencion.length === 0
            ? null
            : x.CodigoSubvencion[0];
        entity.PPresNatuGastoId =
          Utilities.isNullObject(x.NaturalezaGastos) ||
          x.NaturalezaGastos.length === 0
            ? null
            : x.NaturalezaGastos[0];
        entity.ProaRecupCostesId =
          Utilities.isNullObject(x.RecuperacionCostes) ||
          x.RecuperacionCostes.length === 0
            ? null
            : x.RecuperacionCostes[0];
        entity.OCTAVIAPaisId =
          Utilities.isNullObject(x.Pais) || x.Pais.length === 0
            ? null
            : x.Pais[0];
        entity.PPresCodPep = x.Pep;
        entity.EdicionPepLibre = x.EdicionPepLibre

        if (!Utilities.isNullEmptyObject(entity.OCTAVIAFinanciadorSapId)) {
          return entity;
        } else {
          this._tablesContainsNulls = true;
          return null;
        }
      }
    );
    return !Utilities.isEmptyObject(tablesByProject)
      ? tablesByProject.filter((x) => x !== null)
      : null;
  }
  private mappCurrentTableFFCCByProjectEntity() {
    let newTable = this.getDataFromTable("table-by-ffcc");

    if (newTable.length === 0) return null;

    let tablesByProject: Array<ICmdTableBudgetFFCC> = newTable.map((x: any) => {
      const entity: ICmdTableBudgetFFCC = { ...this.getMonthsYearVales(x) };

      entity.Id = x.Id;
      entity.PPresTotalAnio = this.getTotalSum(entity);
      entity.PPresCodProyFFCC = x.CodigoProyectoFFCC;
      entity.OCTAVIAFinanciadorSapId =
        Utilities.isNullObject(x.FinanciadorSap) ||
        x.FinanciadorSap.length === 0
          ? null
          : x.FinanciadorSap[0];
      entity.PPresCodSubvencionId =
        Utilities.isNullObject(x.CodigoSubvencion) ||
        x.CodigoSubvencion.length === 0
          ? null
          : x.CodigoSubvencion[0];
      entity.PPresNatuGastoId =
        Utilities.isNullObject(x.NaturalezaGastos) ||
        x.NaturalezaGastos.length === 0
          ? null
          : x.NaturalezaGastos[0];
      entity.ProaRecupCostesId =
        Utilities.isNullObject(x.RecuperacionCostes) ||
        x.RecuperacionCostes.length === 0
          ? null
          : x.RecuperacionCostes[0];
      entity.PPresDepartamentoId =
        Utilities.isNullObject(x.Departamentos) || x.Departamentos.length === 0
          ? null
          : x.Departamentos[0];
      entity.OCTAVIACodigoProyectoId =
        Utilities.isNullObject(x.CodigoProyecto) ||
        x.CodigoProyecto.length === 0
          ? null
          : x.CodigoProyecto[0];
      entity.EdicionPepLibre = x.EdicionPepLibre
      if (
        !Utilities.isNullObject(x.LineaIntervencion) &&
        x.LineaIntervencion.length > 0
      ) {
        if (
          x.LineaIntervencion[0]
            .toString()
            .indexOf(Constants.Globals.PREFFIX_PURPOSES) !== -1
        ) {
          entity.PPresFinalidadId = parseInt(
            x.LineaIntervencion[0]
              .toString()
              .replace(Constants.Globals.PREFFIX_PURPOSES, String.Empty)
          );
        } else {
          entity.OCTAVIALineaIntervencionId = parseInt(x.LineaIntervencion[0]);
        }
      }

      if (!Utilities.isNullObject(entity.OCTAVIAFinanciadorSapId)) {
        return entity;
      } else {
        this._tablesContainsNulls = true;
        return null;
      }
    });
    return !Utilities.isEmptyObject(tablesByProject)
      ? tablesByProject.filter((x) => x !== null)
      : null;
  }
  private mappCurrentTableFFRRByProjectEntity() {
    let newTable = this.getDataFromTable("table-by-ffrr");
    if (newTable.length === 0) return null;

    let tablesByProject: Array<ICmdTableBudgetFFRR> = newTable.map((x: any) => {
      const entity: ICmdTableBudgetFFRR = { ...this.getMonthsYearVales(x) };

      entity.Id = x.Id;
      entity.PPresTotalAnio = this.getTotalSum(entity);
      entity.OCTAVIAFinanciadorSapId =
        Utilities.isNullObject(x.FinanciadorSap) ||
        x.FinanciadorSap.length === 0
          ? null
          : x.FinanciadorSap[0];
      entity.PPresNatuGastoId =
        Utilities.isNullObject(x.NaturalezaGastos) ||
        x.NaturalezaGastos.length === 0
          ? null
          : x.NaturalezaGastos[0];
      // entity.ProaRecupCostesId =
      //   Utilities.isNullObject(x.RecuperacionCostes) ||
      //   x.RecuperacionCostes.length === 0
      //     ? null
      //     : x.RecuperacionCostes[0];
      entity.PPresCampanasId =
        Utilities.isNullObject(x.Companias) || x.Companias.length === 0
          ? null
          : x.Companias[0];
      entity.PPresCecoId =
        Utilities.isNullObject(x.Ceco) || x.Ceco.length === 0
          ? null
          : x.Ceco[0];
      entity.PPresDepartamentoId =
        entity.PPresCecoId === null || entity.PPresCecoId === 0
          ? 0
          : store
              .getState()
              .budget.formMasters.cecos.find(
                (x: any) => x.Id === entity.PPresCecoId
              ).PPresDepartamentoId;

      if (!Utilities.isNullObject(x.Finalidad) && x.Finalidad.length > 0) {
        let finalidad = x.Finalidad[0];
        if (
          typeof finalidad === "string" &&
          finalidad.indexOf(Constants.Globals.PREFFIX_PURPOSES) !== -1
        ) {
          entity.PPresFinalidadId = parseInt(
            finalidad.replace(Constants.Globals.PREFFIX_PURPOSES, String.Empty)
          );
        } else {
          entity.OCTAVIALineaIntervencionId = parseInt(x.Finalidad[0]);
        }
      }

      if (!Utilities.isNullObject(entity.OCTAVIAFinanciadorSapId) && !Utilities.isNullObject(entity.PPresCecoId)) {
        return entity;
      } else {
        this._tablesContainsNulls = true;
        return null;
      }
    });
    return !Utilities.isEmptyObject(tablesByProject)
      ? tablesByProject.filter((x) => x !== null)
      : null;
  }
  private getDataFromTable(tableId: string): Array<any> {
    
    let element = document.getElementById(tableId);
    if (Utilities.isNullEmptyObject(element)) {
      return [];
    }

    let instance = DataGrid.getInstance(element) as DataGrid;
        return instance.getDataSource().items();
  }

  private getTablesData() {
    let tableBudgetByProject = null;
    let tableFFCC = null;
    let tableFFRR = null;

    if (
      this.currentBudget.PPresTipoPresId == Enums.SystemParameters.BudgetTypeOn
    ) {
      tableFFCC = this.mappCurrentTableFFCCByProjectEntity();
      tableFFRR = this.mappCurrentTableFFRRByProjectEntity();
    } else {
      tableBudgetByProject = this.mappCurrentTableByProjectEntity();
    }    
    return { tableBudgetByProject, tableFFCC, tableFFRR };
  }

  private getMonthsYearVales(x: any) {
    return {
      PPresEnero: Utilities.isNullObject(x.Enero) ? 0 : parseFloat(x.Enero),
      PPresFebrero: Utilities.isNullObject(x.Febrero)
        ? 0
        : parseFloat(x.Febrero),
      PPresMarzo: Utilities.isNullObject(x.Marzo) ? 0 : parseFloat(x.Marzo),
      PPresAbril: Utilities.isNullObject(x.Abril) ? 0 : parseFloat(x.Abril),
      PPresMayo: Utilities.isNullObject(x.Mayo) ? 0 : parseFloat(x.Mayo),
      PPresJunio: Utilities.isNullObject(x.Junio) ? 0 : parseFloat(x.Junio),
      PPresJulio: Utilities.isNullObject(x.Julio) ? 0 : parseFloat(x.Julio),
      PPresAgosto: Utilities.isNullObject(x.Agosto) ? 0 : parseFloat(x.Agosto),
      PPresSeptiembre: Utilities.isNullObject(x.Septiembre)
        ? 0
        : parseFloat(x.Septiembre),
      PPresOctubre: Utilities.isNullObject(x.Octubre)
        ? 0
        : parseFloat(x.Octubre),
      PPresNoviembre: Utilities.isNullObject(x.Noviembre)
        ? 0
        : parseFloat(x.Noviembre),
      PPresDiciembre: Utilities.isNullObject(x.Diciembre)
        ? 0
        : parseFloat(x.Diciembre),
      PPresTotalAnio: Utilities.isNullObject(x.TotalAnio)
        ? 0
        : parseFloat(x.TotalAnio),
    };
  }

  private getTotalSum(x: any) {
    return (
      x.PPresEnero +
      x.PPresFebrero +
      x.PPresMarzo +
      x.PPresAbril +
      x.PPresMayo +
      x.PPresJunio +
      x.PPresJulio +
      x.PPresAgosto +
      x.PPresSeptiembre +
      x.PPresOctubre +
      x.PPresNoviembre +
      x.PPresDiciembre
    );
  }

  //#endregion
}
